
import { Options, Vue } from 'vue-class-component'
import { mapState, mapMutations } from 'vuex'
import Timeline from '@/components/Timeline.vue'
import News from '@/components/News.vue'
import Topic from '@/components/Topic.vue'
import ImageSwiper from '@/components/Image.vue'

import COVERAPP from '@/utils/COVERAPP'
import Config from '@/utils/config'

@Options({
    data() {
      return {
        dt: [],
        py: [],
        gs: [],
        sd: [],
        qz: [],
        topic: [],
      }
    },
    computed: {
        ...mapState(['userInfo', 'shareData', 'activityData'])
    },
    components: {
      Timeline,
      News,
      Topic,
      ImageSwiper,
    },
    created() {
      const { templateConfig } = this.activityData;
      if (templateConfig.isSubject) {
        this.getList();
      }
      
      if (templateConfig.isTopic) {
        this.getTopic();
      }
    },
    mounted () {
        this.$common.pageLoaded()
        let homeShareData = JSON.parse(JSON.stringify(this.shareData))
        homeShareData.link = window.location.href
        this.$common.onshare(homeShareData)
        this.$common.track('load', '进入首页')
    },
    methods: {
      ...mapMutations(['SET_USERINFO', 'SET_SHAREDATA', 'SET_DIALOGDATA' , 'SET_ACTIVITYDATA']),
      getList() {
        this.$http('/wap/getSubjectInfo', {
          subject_id: 9503
        }).then(res => {
          const list = res.list;
          list.forEach(item => {
            if (item.category_id == 7396) {
              this.dt = item.news;
            }

            if (item.category_id == 7398) {
              this.py = item.news;
            }

            if (item.category_id == 7397) {
              this.gs = item.news;
            }

            if (item.category_id == 7400) {
              this.sd = item.news;
            }

            if (item.category_id == 7405) {
              this.qz = item.news;
            }
          });

          this.SET_SHAREDATA({
            title: res.share_title,
            desc: res.subject_desc,
            imgUrl: 'https://wapcdn.thecover.cn/cdn/wap/img/fengmian_logo.png',
            link: window.location.href
          })
        });
      },
      getTopic() {
        this.$http('/wap/wapTopic/topicInfo', {
          topic_id: 2579
        }).then(res => {
          this.topic = res.dynamic || [];
        });
      },
      cateLink(id) {
        if (COVERAPP.Attribute.isApp()) {
          return `${Config.APP_SCHEME_URL}/news?id=0&flag=204&subjectid=9503&catename=云求助&cateid=${ id }`;
        } else {
          return `https://m.thecover.cn/subject_detail.html?subjid=9503&cateid=${ id }`;
        }
      },
      topicLink() {
        if (COVERAPP.Attribute.isApp()) {
          return `${Config.APP_SCHEME_URL}/news?id=2579&flag=100`;
        } else {
          return 'https://m.thecover.cn/topic.html?topic_id=2579';
        }
      },
    },
})
export default class Home extends Vue {}
